import { NgModule } from '@angular/core';
import { BpTableDirective, BpTableHeadDirective } from './table';

@NgModule({
  declarations: [
    BpTableDirective,
    BpTableHeadDirective
  ],
  exports: [
    BpTableDirective,
    BpTableHeadDirective
  ]
})
export class BpTableModule { }
